// extracted by mini-css-extract-plugin
export var listItem = "PagePress-module--listItem--PX7om";
export var listTitle = "PagePress-module--listTitle--0ZMzA";
export var logoItem = "PagePress-module--logoItem--NYDrt";
export var materialWrapper = "PagePress-module--materialWrapper--O5HGM";
export var title = "PagePress-module--title--b8hXl";